/* eslint-disable class-methods-use-this */

import { Component } from 'react';
import history from './history';

export default class Auth extends Component {
  constructor(props) {
    super(props);
    this.logout = this.logout.bind(this);
    this.isAuthenticated = this.isAuthenticated.bind(this);
    this.blockFromAdmin = this.blockFromAdmin.bind(this);
  }

  blockFromAdmin() {
    // navigate to the home page
    history.replace('/home');
  }

  logout() {
    localStorage.clear();
    // navigate to the login page
    history.replace('/');
  }

  isAuthenticated() {
    const userId = localStorage.getItem('userId');
    const token = localStorage.getItem('token');
    const refreshToken = localStorage.getItem('refreshToken');
    return token && userId && refreshToken;
  }
}
